{
  "chart": {
    "header": "Ramverk",
    "linkedDocumentsOutsideCategory": "Länkade dokument utanför denna kategori",
    "showCategories": "Gruppera efter kategorier"
  }
}
